import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "./AuthContext";

const PublicOnlyRoute = () => {
    const { status } = useAuth();

    if (status === "loading") return null;
    if (status === "authenticated") return <Navigate to="/principal" replace />;
    return <Outlet />;
};

export default PublicOnlyRoute;
